module.exports = __webpack_public_path__ + "static/media/dollar-green.0a29d39f.svg";